import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  active: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
  inactive: {
    backgroundColor: theme.palette.dashboard.chart.primary.inactive,
    color: theme.palette.common.white,
  },
}))

export default useStyles
